import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call, select } from 'redux-saga/effects';
import { ApiStateData, MakerSelectors, UserRFC } from 'types';

import { authSignIn } from './authSignIn';

type Data = {
  userRfcs: Array<UserRFC>;
};

interface ExtraSelectors extends MakerSelectors<ApiStateData<Data>> {
  getUserRfcs: (d: ApiStateData<Data>) => Array<UserRFC>;
}

export const rfcsFetch = createApiSlice<Data, undefined, ExtraSelectors>({
  name: 'rfcsFetch',
  *tryGenerator() {
    const { username } = yield select(authSignIn.selectors.getData);

    const { data } = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({ path: '/auth/user/:username/rfcData', urlParams: { username } }),
    });

    return data;
  },
  extraSelectors: {
    getUserRfcs: (data) => data?.userRfcs || [],
  },
});
